<template>
  <div>
    <v-card flat>
      <v-col class="pa-0">
        <s-crud
          ref="crud"
          no-border
          :add="true"
          :remove="true"
          title="Adendas del Fundo"
          :config="configCrud"
          :filter="filter"
          @save="save($event)"
          @clearForm="onClearForm"
          height="250"
          close
          @close="close()"
          @returnObject="onAdendaChanged"
          @removed="onAdendaChanged"
        >
          <!-- FORMULARIO DE REGISTRO INTEGRADO -->
          <template slot-scope="props">
            <v-container v-if="props.item != null" class="pb-0">
              <v-row justify="start" dense>
                <v-col cols="12" sm="3">
                  <s-date
                    v-model="props.item.BeginDate"
                    label="Fecha Inicio"
                    clearable
                  ></s-date>
                </v-col>
                <v-col cols="12" sm="3">
                  <s-date
                    v-model="props.item.EndDate"
                    label="Fecha Fin"
                    clearable
                  ></s-date>
                </v-col>
              </v-row>
              <v-row justify="start" dense class="mt-2">
                <v-col cols="6">
                  <s-select-responsible-collecting-farm-lot
                    v-model="props.item.FrcID"
                    :FltID="FltID"
                    label="Responsable por Cobrar"
                    clearable
                  ></s-select-responsible-collecting-farm-lot>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <!-- DISEÑO DE COLUMNA DE ESTADO CDASTATUS -->
          <template v-slot:CdaStatus="{ row }">
            <v-chip
              style="margin: 0px"
              x-small
              :color="row.CdaStatus == 1 ? 'success' : 'default'"
            >
              {{ row.CdaStatus == 1 ? "Activo" : "Inactivo" }}
            </v-chip>
          </template>
        </s-crud>
      </v-col>
    </v-card>
  </div>
</template>

<script>
import _sAddenda from "@/services/Technicalassistance/TasProducerContractDetailAddendaService";
import sSelectResponsibleCollectingFarmLot from "@/components/TecnicalAssistence/ProducersFarms/sSelectResponsibleCollectingFarmLot.vue";

export default {
  name: "sProducerContractDetailAddenda",
  components: {
    sSelectResponsibleCollectingFarmLot,
  },
  props: {
    PcdID: { type: Number, default: 0 },
    FltID: { type: Number, default: 0 },
    contractBeginDate: { type: String, default: "" },
    contractEndDate: { type: String, default: "" },
  },
  data() {
    return {
      filter: {},
    };
  },
  computed: {
    configCrud() {
      return {
        model: {
          CdaID: "ID",
          PcdID: "int",
          BeginDate: "date",
          EndDate: "date",
          FrcID: "int",
          CdaStatus: "int",
        },
        service: _sAddenda,
        headers: [
          { text: "ID", value: "CdaID", sortable: false, width: 60 },
          {
            text: "Fecha Inicio",
            value: "BeginDate",
            sortable: false,
            width: 150,
          },
          { text: "Fecha Fin", value: "EndDate", sortable: false, width: 150 },
          { text: "Responsable Cobro", value: "FullName", sortable: false },
          {
            text: "Estado Adenda",
            value: "CdaStatus",
            align: "center",
            sortable: false,
            width: 100,
          },
        ],
      };
    },
  },
  methods: {
    Initialize() {
      this.filter = { PcdID: this.PcdID };
    },
    close() {
      this.$emit("close");
    },
    onAdendaChanged() {
      this.$emit("adendaChanged");
    },
    save(item) {
      item.PcdID = this.PcdID;
      item.UsrCreateID = item.UsrCreateID || this.$fun.getUserID();
      item.UsrUpdateID = this.$fun.getUserID();

      if (!item.BeginDate) {
        this.$fun.alert("Debe seleccionar la Fecha de Inicio", "warning");
        return;
      }
      if (!item.EndDate) {
        this.$fun.alert("Debe seleccionar la Fecha de Fin", "warning");
        return;
      }
      if (!item.FrcID || item.FrcID <= 0) {
        this.$fun.alert(
          "Debe seleccionar el Responsable por Cobrar",
          "warning",
        );
        return;
      }

      // Guardar y refrescar la tabla del CRUD interna
      item.save();
    },
    onClearForm() {
      this.$nextTick(() => {
        if (this.$refs.crud) {
          const row = this.$refs.crud.row;
          if (row) {
            // Si la fecha de inicio está vacía, rellenar con la fecha de hoy
            if (!row.BeginDate) {
              const todayStr = this.$moment().format(this.$const.FormatDateDB || "YYYY-MM-DD");
              this.$set(row, "BeginDate", todayStr);
            }

            // Si la fecha de fin está vacía y tenemos fecha fin del contrato, rellenar con ella
            if (!row.EndDate && this.contractEndDate) {
              const parsedDate = this.$moment(this.contractEndDate, [
                this.$const.FormatDateDB || "YYYY-MM-DD",
                this.$const.FormatDateView || "DD/MM/YYYY",
                "YYYY-MM-DD",
                "DD/MM/YYYY",
                "YYYY-MM-DDT00:00:00"
              ]);
              if (parsedDate.isValid()) {
                const endDateFormatted = parsedDate.format(this.$const.FormatDateDB || "YYYY-MM-DD");
                this.$set(row, "EndDate", endDateFormatted);
              }
            }
          }
        }
      });
    },
  },
  watch: {
    PcdID() {
      this.Initialize();
    },
  },
  created() {
    this.filter = { PcdID: this.PcdID };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.crud) {
        this.$watch(
          () => this.$refs.crud.showForm,
          (newVal) => {
            if (newVal) {
              const row = this.$refs.crud.row;
              if (row && !row.CdaID) {
                // Si la fecha de inicio está vacía, rellenar con la fecha de hoy
                if (!row.BeginDate) {
                  const todayStr = this.$moment().format(this.$const.FormatDateDB || "YYYY-MM-DD");
                  this.$set(row, "BeginDate", todayStr);
                }

                // Si la fecha de fin está vacía y tenemos fecha fin del contrato, rellenar con ella
                if (!row.EndDate && this.contractEndDate) {
                  const parsedDate = this.$moment(this.contractEndDate, [
                    this.$const.FormatDateDB || "YYYY-MM-DD",
                    this.$const.FormatDateView || "DD/MM/YYYY",
                    "YYYY-MM-DD",
                    "DD/MM/YYYY",
                    "YYYY-MM-DDT00:00:00"
                  ]);
                  if (parsedDate.isValid()) {
                    const endDateFormatted = parsedDate.format(this.$const.FormatDateDB || "YYYY-MM-DD");
                    this.$set(row, "EndDate", endDateFormatted);
                  }
                }
              }
            }
          }
        );
      }
    });
  },
};
</script>

<style scoped></style>
